import { transformDateValue } from 'core/js/FormUtils';
export const getMfdigitalstatusView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mfdigitalstatusList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                              {"fieldLabel":"Business Id","fieldValue":transformDataValue(data.businessid,"ID"), "fieldType":"ID"},
              
              ]
          }

          mfdigitalstatusList.push(card);
  })
  return mfdigitalstatusList;
}